import './search.js';

const getCurrentTheme = () => {
  const currentTheme = localStorage.getItem('theme');

  if (currentTheme) {
    return currentTheme;
  }

  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }

  return 'light';
};

const currentTheme = getCurrentTheme();

document.documentElement.setAttribute('data-theme', currentTheme);

// Sync all theme toggles (desktop + mobile)
const themeToggles = document.querySelectorAll('.theme-switch input[type="checkbox"]');

themeToggles.forEach((toggle) => {
  if (currentTheme === 'dark') {
    toggle.checked = true;
  }
});

function switchTheme(e) {
  const isDark = e.target.checked;
  document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
  localStorage.setItem('theme', isDark ? 'dark' : 'light');
  themeToggles.forEach((toggle) => {
    if (toggle !== e.target) {
      toggle.checked = isDark;
    }
  });
}

themeToggles.forEach((toggle) => toggle.addEventListener('change', switchTheme, false));

// Remove FOUC guard from all theme switcher wrappers
document.querySelectorAll('.theme-switch-wrapper').forEach((el) => el.classList.remove('hidden'));

// Hamburger menu
const hamburgerBtn = document.querySelector('.hamburger-btn');
const mobileMenu = document.getElementById('mobile-menu');

function openMobileMenu() {
  mobileMenu.removeAttribute('hidden');
  hamburgerBtn.setAttribute('aria-expanded', 'true');
}

function closeMobileMenu() {
  mobileMenu.setAttribute('hidden', '');
  hamburgerBtn.setAttribute('aria-expanded', 'false');
}

hamburgerBtn?.addEventListener('click', () => {
  mobileMenu.hasAttribute('hidden') ? openMobileMenu() : closeMobileMenu();
});

mobileMenu?.querySelectorAll('a').forEach((el) => {
  el.addEventListener('click', closeMobileMenu);
});
